import { CircularProgress, Box, styled, Button } from '@mui/material';
import styledComponent from 'styled-components';

export const OverlayContainer = styled(Box)(
  () => `
  display: flex;
  flex-direction: row;
  max-width: 100%;
  min-width: 350px;
  position: absolute;
  right: -10px;
  top: -12px;
  margin-top: 60px;
  z-index: 1301;
  background: #F5F5FF;
  border-radius: 16px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  `
);

export const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  width: '30px',
  height: '30px',
  color: theme.palette.primary.main,
}));

export const StyledEditButtonWrapper = styledComponent(Box)`
  ${({ theme }) => `
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: ${theme.uptimeSpace[3]}px ${theme.uptimeSpace[4]}px;
    cursor: pointer;
    svg {
      color: ${theme.uptimeColors.generalColors.button.hyperlink.enabled};
      margin-right: ${theme.uptimeSpace[6]}px;
    }
    p {
      color: ${theme.uptimeColors.generalColors.button.hyperlink.enabled};
      padding-bottom: ${theme.uptimeSpace[2]}px;
    }
    &:hover {
      svg {
        color: ${theme.uptimeColors.generalColors.button.hyperlink.hover};
      }
      p {
        color: ${theme.uptimeColors.generalColors.button.hyperlink.hover};
        text-decoration: underline;
      }
    }
  `}
`;

export const StyledButton = styledComponent(Button)`
  ${({ theme }) =>`
    font-family: ${theme.uptimeFonts.primary};
    background-color: transparent;
    &:hover {
      .edit-icon, .edit-btn, .abo-btn-link {
        color: ${theme.uptimeColors?.generalColors?.button?.hyperlink?.hover} !important;
      }
      .abo-icon {
        path {
          fill: ${theme.uptimeColors?.generalColors?.button?.hyperlink?.hover} !important;
        }
      }
    }
  `} 
`;